// Packages
import ListItem from 'modules/Placements/components/ListItem';
import PropTypes from 'prop-types';

const PlacementList = ({ isLoading, items, onChange }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='PlacementList'>
				<ListItem isLoading={true} index={''}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No Placements to show here</h3>
		)
	}


	// Data State
	return (
		<div className='PlacementList'>

			{items.map((item, index) => {

				return (
						<ListItem 
							{...item} 
							key={index}
							index={index}
							isLoading={false}
							onChange={() => {onChange()}}
						/>
				)
				
			})}
	
		</div>
	)
}

PlacementList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
}

PlacementList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
}

export default PlacementList;